import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import Leftmenu from "../../components/Leftmenu";
import Rightmenu from "../../components/Rightmenu";
import Pagination from "../../components/Pagination";
import { Link, useOutletContext, useNavigate } from "react-router-dom";
import moment from "moment";
import df from "../../../images/Default_pfp.jpg";

function AdminPendingPosts() {
  const { user, token } = useOutletContext();
  const navigate = useNavigate();
  const [posts, setPosts] = useState([]);
  const [statusFilter, setStatusFilter] = useState("pending");
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [processingId, setProcessingId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
    total: 0,
    from: 0,
    to: 0,
  });

  useEffect(() => {
    if (user && user.role !== "admin") {
      navigate("/");
      return;
    }
    fetchPosts(statusFilter, currentPage, search);
  }, [user, statusFilter, currentPage]);

  const fetchPosts = (filter, page = 1, searchVal = search) => {
    setLoading(true);
    fetch(`/api/admin/posts?page=${page}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ status: filter, page, search: searchVal }),
    })
      .then((res) => res.json())
      .then((resData) => {
        setLoading(false);
        if (resData.data?.data) {
          setPosts(resData.data.data);
          setPagination({
            current_page: resData.data.current_page,
            last_page: resData.data.last_page,
            total: resData.data.total,
            from: resData.data.from,
            to: resData.data.to,
          });
        } else if (Array.isArray(resData.data)) {
          setPosts(resData.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching posts:", err);
        setLoading(false);
      });
  };

  const handleFilterChange = (newFilter) => {
    setStatusFilter(newFilter);
    setCurrentPage(1);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setCurrentPage(1);
    fetchPosts(statusFilter, 1, search);
  };

  const handleUpdateStatus = (postId, newStatus) => {
    setProcessingId(postId);
    fetch("/api/admin/update-post-status", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ post_id: postId, status: newStatus }),
    })
      .then((res) => res.json())
      .then((data) => {
        setProcessingId(null);
        if (data.message) {
          fetchPosts(statusFilter, currentPage, search);
        } else if (data.error) {
          alert(data.error);
        }
      })
      .catch((err) => {
        console.error(err);
        setProcessingId(null);
      });
  };

  const handleDeletePost = (postId) => {
    if (!window.confirm("Are you sure you want to delete this post?")) return;
    setProcessingId(postId);
    fetch("/api/post-delete", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ post_id: postId }),
    })
      .then((res) => res.json())
      .then((data) => {
        setProcessingId(null);
        if (data.message) {
          fetchPosts(statusFilter, currentPage, search);
        } else if (data.error) {
          alert(data.error);
        }
      })
      .catch((err) => {
        console.error(err);
        setProcessingId(null);
      });
  };

  return (
    <div>
      <Header />
      <Leftmenu />
      <div className="main-content bg-lightblue theme-dark-bg admin-main-page" style={{ minHeight: "100vh" }}>
        <div className="middle-sidebar-bottom">
          <div className="middle-sidebar-left w-100" style={{ maxWidth: "100%", margin: 0, paddingRight: 0 }}>
            <div className="admin-wrap-full w-100" style={{ maxWidth: "100%", margin: 0 }}>
              {/* Header Card */}
              <div className="card w-100 border-0 bg-white shadow-xs p-0 mb-4 rounded-xxl overflow-hidden">
                <div className="card-body p-4 w-100 bg-current border-0 d-flex align-items-center justify-content-between rounded-3">
                  <div className="d-flex align-items-center">
                    <Link to="/admin/dashboard" className="text-white me-3">
                      <i className="feather-arrow-left font-sm"></i>
                    </Link>
                    <div>
                      <h4 className="font-xs text-white fw-600 mb-0">Pending Posts Moderation</h4>
                      <span className="font-xssss text-white opacity-75">Review, approve, or ban submitted alumni posts</span>
                    </div>
                  </div>
                  <Link to="/admin/dashboard" className="btn btn-sm btn-light font-xssss fw-600 px-3 py-1 rounded-pill">
                    &larr; Dashboard
                  </Link>
                </div>
              </div>

              {/* Status Filter and Search Bar */}
              <div className="card shadow-xss border-0 p-3 rounded-xxl bg-white mb-4">
                <div className="row g-2 align-items-center justify-content-between">
                  <div className="col-lg-7">
                    <div className="d-flex flex-wrap gap-2">
                      <button
                        type="button"
                        className={`btn btn-sm font-xssss fw-600 px-3 py-2 rounded-xl ${
                          statusFilter === "pending" ? "btn-danger text-white" : "btn-light text-grey-700"
                        }`}
                        onClick={() => handleFilterChange("pending")}
                      >
                        Pending Approval
                      </button>
                      <button
                        type="button"
                        className={`btn btn-sm font-xssss fw-600 px-3 py-2 rounded-xl ${
                          statusFilter === "approved" ? "btn-success text-white" : "btn-light text-grey-700"
                        }`}
                        onClick={() => handleFilterChange("approved")}
                      >
                        Approved Posts
                      </button>
                      <button
                        type="button"
                        className={`btn btn-sm font-xssss fw-600 px-3 py-2 rounded-xl ${
                          statusFilter === "banned" ? "btn-warning text-dark" : "btn-light text-grey-700"
                        }`}
                        onClick={() => handleFilterChange("banned")}
                      >
                        Banned Posts
                      </button>
                      <button
                        type="button"
                        className={`btn btn-sm font-xssss fw-600 px-3 py-2 rounded-xl ${
                          statusFilter === "all" ? "btn-dark text-white" : "btn-light text-grey-700"
                        }`}
                        onClick={() => handleFilterChange("all")}
                      >
                        All Posts
                      </button>
                    </div>
                  </div>

                  <div className="col-lg-5">
                    <form onSubmit={handleSearchSubmit} className="d-flex gap-2">
                      <input
                        type="text"
                        placeholder="Search all posts by content, author..."
                        className="form-control font-xssss border-light-md rounded-xl"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                      <button type="submit" className="btn bg-current text-white font-xssss fw-600 px-3 rounded-xl">
                        Search
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-secondary font-xssss fw-600 px-2 rounded-xl"
                        onClick={() => { setSearch(""); fetchPosts(statusFilter, currentPage, ""); }}
                        title="Clear search"
                      >
                        <i className="feather-refresh-cw"></i>
                      </button>
                    </form>
                  </div>
                </div>
              </div>

              {/* Posts List */}
              {loading ? (
                <div className="card shadow-xss border-0 p-5 rounded-xxl bg-white text-center">
                  <div className="spinner-border text-danger" role="status"></div>
                  <p className="mt-3 text-grey-600 font-xsss mb-0">Loading posts...</p>
                </div>
              ) : posts.length > 0 ? (
                <div className="d-flex flex-column gap-3">
                  {posts.map((post) => (
                    <div key={post.id} className="card shadow-xss border-0 rounded-xxl bg-white overflow-hidden">
                      <div className="card-body p-4">
                        {/* Author Header */}
                        <div className="d-flex align-items-center justify-content-between mb-3">
                          <div className="d-flex align-items-center">
                            <img
                              src={post.user?.personal_details?.profile_picture || df}
                              alt="author"
                              className="rounded-circle me-3"
                              style={{ width: "45px", height: "45px", objectFit: "cover" }}
                            />
                            <div>
                              <h5 className="font-xsss fw-700 text-grey-900 mb-0">{post.user?.name || "Unknown Author"}</h5>
                              <div className="d-flex align-items-center gap-2">
                                <span className="font-xsssss text-grey-500">{post.user?.email}</span>
                                <span className="font-xsssss text-grey-400">&bull;</span>
                                <span className="font-xsssss text-grey-500">{moment(post.created_at).fromNow()}</span>
                              </div>
                            </div>
                          </div>

                          {/* Post Status Badge */}
                          <div className="d-flex align-items-center gap-2">
                            <span
                              className={`badge font-xsssss text-uppercase px-3 py-1 rounded-pill ${
                                post.status === "approved"
                                  ? "bg-success text-white"
                                  : post.status === "banned"
                                  ? "bg-danger text-white"
                                  : "bg-warning text-dark"
                              }`}
                            >
                              {post.status}
                            </span>
                            <span className="font-xsssss text-grey-400">#{post.id}</span>
                          </div>
                        </div>

                        {/* Content */}
                        <div className="mb-3">
                          <p className="font-xsss fw-500 text-grey-800 lh-26 mb-0">
                            {post.content || <em className="text-muted">No text content</em>}
                          </p>
                        </div>

                        {/* Images */}
                        {post.images && post.images.length > 0 && (
                          <div className="row g-2 mb-3">
                            {post.images.map((img, idx) => (
                              <div key={idx} className="col-md-3 col-sm-4 col-6">
                                <img
                                  src={img.image_path}
                                  alt="post media"
                                  className="rounded-3 w-100 shadow-xs"
                                  style={{ height: "120px", objectFit: "cover" }}
                                />
                              </div>
                            ))}
                          </div>
                        )}

                        {/* Action Buttons */}
                        <div className="d-flex align-items-center justify-content-between pt-3 border-top">
                          <span className="font-xsssss text-grey-500">
                            <i className="feather-thumbs-up me-1"></i> {post.likes_count || 0} Likes
                          </span>
                          <div className="d-flex gap-2">
                            {post.status !== "approved" && (
                              <button
                                type="button"
                                className="btn btn-sm btn-success font-xssss fw-600 px-3 py-1 rounded-2"
                                disabled={processingId === post.id}
                                onClick={() => handleUpdateStatus(post.id, "approved")}
                              >
                                <i className="feather-check-circle me-1"></i> Approve Post
                              </button>
                            )}
                            {post.status !== "banned" && (
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-warning font-xssss fw-600 px-3 py-1 rounded-2"
                                disabled={processingId === post.id}
                                onClick={() => handleUpdateStatus(post.id, "banned")}
                              >
                                <i className="feather-slash me-1"></i> Ban Post
                              </button>
                            )}
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-danger font-xssss fw-600 px-3 py-1 rounded-2"
                              disabled={processingId === post.id}
                              onClick={() => handleDeletePost(post.id)}
                            >
                              <i className="feather-trash-2 me-1"></i> Delete
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}

                  {/* Pagination Card */}
                  <div className="card shadow-xss border-0 p-3 rounded-xxl bg-white">
                    <Pagination
                      currentPage={pagination.current_page}
                      lastPage={pagination.last_page}
                      total={pagination.total}
                      from={pagination.from}
                      to={pagination.to}
                      onPageChange={(p) => setCurrentPage(p)}
                      itemName="posts"
                    />
                  </div>
                </div>
              ) : (
                <div className="card shadow-xss border-0 p-5 rounded-xxl bg-white text-center">
                  <i className="feather-check-circle font-xxl text-success mb-2 d-block"></i>
                  <h5 className="fw-700 font-xs text-grey-800 mb-1">No Posts Found</h5>
                  <p className="text-grey-500 font-xssss mb-0">
                    {search ? `No posts matched "${search}".` : `There are no ${statusFilter} posts awaiting moderation.`}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminPendingPosts;
